import { FormCheck, Offcanvas } from "react-bootstrap";
import { IoCloseOutline, IoDocument, IoDownload, IoInformationCircle, IoOpenOutline, IoPencil, IoPricetags, IoTime } from "react-icons/io5";
import OffCanvasCloseBtn from "./OffCanvasCloseBtn";
import moment from "moment";
import { PAYMENT_METHODS } from "constants";
import { useEffect, useMemo, useState } from "react";
import { useAuthValue } from "context/AuthContext";
import axios from "axios";
import useHistory from "pages/history/useHistory";

export function OffCanvasBody({
    orderData,
    handleClose,
    handleUpdateOrder
}) {

    const completed = orderData.plan.task?.status === 'DONE';

    const [isConfirmPayed, setIsConfirmPayed] = useState(orderData?.is_confirm_payed);

    const { user } = useAuthValue();

    const handleChange = (e) => {
        setIsConfirmPayed(!isConfirmPayed);
        const { name, value, checked } = e.target;
        const newValue = name === 'is_confirm_payed' ? checked : value;
        axios.put(`/orders/${orderData.id}`, {
            [name]: newValue,
        }).then(res => {
            handleUpdateOrder(orderData.id, res.data);
        })
    }

    if (!orderData) return;

    return (<>
        <div
            style={{ backgroundImage: `url('${process.env.REACT_APP_PUBLIC_URL}img/plan.jpeg')`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundColor: '#f6f6f6' }}
            className="property-card-header small"
        >
            <OffCanvasCloseBtn handleClose={handleClose} />

        </div>

        <div className="action-sheet-content py-2 px-0 noarrow">
            <div className="listview-title pb-0">
                <h3 className="mb-0 w-100">
                    {orderData.plan.product}
                    <span 
                        className={`badge bg-${completed ? 'success' : 'primary'} ms-1 float-end`}
                    >{completed ? 'COMPLETATO' : 'IN CORSO'}</span>
                </h3>
            </div>
            <ul className="listview image-listview no-border">
                <li>
                    <div className="item">
                        <div className="in">
                            <div>
                                <header>
                                    <IoTime /> Data richiesta:
                                </header>
                                {moment(orderData.created_at).format('DD/MM/YYYY HH:mm')}
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="item">
                        <div className="in">
                            <div>
                                <header>
                                    <IoPricetags /> Totale pagato:
                                </header>
                                {orderData.total} € + IVA ({PAYMENT_METHODS[orderData.payment_method]})
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="item">
                        <div className="in">
                            <div>
                                <header>
                                    <IoDocument /> Planimetria da elaborare:
                                </header>
                                <a 
                                    className='active'
                                    href={orderData.plan.instructions_file.url}
                                    target="_blank"
                                >{orderData.plan.instructions_file.name} <IoOpenOutline className='vertical-align-n2'/></a>
                            </div>
                        </div>
                    </div>
                </li>
                { orderData?.payment_method === 'BACS'  && 
                    <li>
                        <div className='custom-status custom-switch justify-content-between '>
                            <header><IoInformationCircle  /> Stato Pagamento: </header>
                                { user.is_admin ?
                                    ( <FormCheck
                                    className="me-3"
                                        id="edituserbacs"
                                        type="switch"
                                        name="is_confirm_payed"
                                        label=""
                                        checked={isConfirmPayed}
                                        onChange={(e) => {
                                            handleChange(e);
                                            // qui mi deve lanciare l'api che aggiorna lo stato
                                        }}
                                    /> 
                                    )
                                    :
                                    (
                                        orderData?.is_confirm_payed ? <span className="badge bg-success me-3">Pagato</span> : <span className="badge bg-danger me-3">Non pagato</span>
                                    )
                                }
                        </div>
                    </li>
                }
                <li>
                    <div className="item">
                        <div className="in">
                            <div className="flex-fill">
                                <header>
                                    <IoPencil /> Note aggiuntive:
                                </header>
                                {orderData.plan.instructions}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div className="form-group mb-2 section">
            <a 
                type="button" 
                className={`btn-block btn btn-primary ${(completed && orderData.plan?.delivery_file?.url) ? '' : 'disabled'}`}
                href={orderData.plan?.delivery_file?.url}
                target="_blank"
            >
                <IoDownload/>Scarica planimetria
            </a>
        </div>

    </>)
}

export default function OffCanvasViewPlan(props) {

    return (<>
        <Offcanvas
            placement="bottom"
            className="action-sheet placeholder-glow"
            show={true}
        //show={!!plantId}
        //onHide={handleClose}
        >
            <Offcanvas.Body>
                <OffCanvasBody />
            </Offcanvas.Body>
        </Offcanvas>
    </>);

    }